export default __webpack_public_path__ + "static/media/inquizitorapp.6266f1e6.png";